import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BiConversation } from 'react-icons/bi';

import Loading from '../Loading.jsx';
import Select from '../Form/Select.jsx';
import HeaderContainer from '../HeaderContainer.jsx';
import Pagination from '../../components/Custom-UI/Tables/Pagination.jsx';
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  TableButton,
  CellName,
} from '../../components/Custom-UI/Tables/Elements.jsx';
// import { SortData } from '../../components/Custom-UI/Tables/Filters.jsx';
import { getDateFromISODate } from '../../utils/date.js';
import { useGetChats } from '../../models/chat.js';
import { useGetLearnunits } from '../../models/learnunits.js';

const ChatTable = () => {
  const navigate = useNavigate();
  const [itemsPerPage, setItemPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseLearnunitFilter, setCourseLearnunitFilter] = useState('');
  // const [searchFilter, setSearchFilter] = useState('');
  const [learnunitsData] = useGetLearnunits();
  const [pagination, setPagination] = useState({
    currentPage: page,
    itemsPerPage: itemsPerPage,
    totalPages: chats?.length,
  });
  const [data, dataLoading] = useGetChats({
    page: page,
    limit: itemsPerPage,
    learnunitFilter: courseLearnunitFilter,
    // searchFilter: searchFilter,
  });

  const options = [{ value: '', label: <em>Todas</em> }];
  if (learnunitsData) {
    learnunitsData?.data?.forEach(learnunit => {
      options.push({ value: learnunit.id, label: learnunit.name });
    });
  }

  // function handleSearch(option) {
  //   setSearchFilter(option.target.value);
  //   setPage(1);
  //   setLoading(true);
  // }

  function handleCourseLearnunit(option) {
    setCourseLearnunitFilter(option.target.value);
    setPage(1);
    setLoading(true);
  }

  useEffect(() => {
    if (data && !dataLoading) {
      setChats(data.chats);
      setPagination({
        currentPage: data.pagination.currentPage,
        itemsPerPage: itemsPerPage,
        totalPages: data.pagination.totalPages,
      });
      setLoading(false);
    }
  }, [data, dataLoading]);

  return (
    <section className='antialiased font-sans w-full'>
      <div className='divide-y divide-primary'>
        <HeaderContainer
          title='Chats'
          // search={{ handleSearch: handleSearch }}
        />
        <div className='py-8 px-4 sm:px-8 min-w-full w-full'>
          <div className='mb-4 flex sm:flex-row flex-col'>
            <Select
              name='learnunit'
              label='Unidad de Aprendizaje'
              value={courseLearnunitFilter}
              onChange={handleCourseLearnunit}
              options={options}
              sx={{ minWidth: '210px' }}
            />
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableHeader className='w-72 min-w-72'>Usuario</TableHeader>
                <TableHeader className='w-[24rem]'>Unidad de aprendizaje</TableHeader>
                <TableHeader>N° Consultas</TableHeader>
                <TableHeader>Fecha de creación</TableHeader>
                <TableHeader></TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan='5'>
                    <div className='flex justify-center items-center h-full'>
                      <Loading />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                chats.map(chat => (
                  <TableRow key={chat.id}>
                    <TableCell>
                      <CellName
                        firstLabel={'Nombre'}
                        firstField={chat.user.firstnames}
                        secondLabel={'Apellido'}
                        secondField={chat.user.lastnames}
                      />
                    </TableCell>
                    <TableCell type={'name'}>{chat.name}</TableCell>
                    <TableCell type={'name'}>{chat.messageCount}</TableCell>
                    <TableCell type={'date'}>
                      {getDateFromISODate(chat.details.createdAt)}
                    </TableCell>
                    <TableCell>
                      <TableButton variant={'text'} onClick={() => navigate(`/chats/${chat.id}`)}>
                        <div className='inline-flex items-center my-2'>
                          <div className='mr-1 mt-[0.1rem]'>
                            <BiConversation />
                          </div>
                          Mensajes
                        </div>
                      </TableButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
          <Pagination
            pagination={pagination}
            setPage={setPage}
            setLoading={setLoading}
            setItemPerPage={setItemPerPage}
          />
        </div>
      </div>
    </section>
  );
};

export default ChatTable;
